<template>
  <v-popover
      placement="bottom"
      offset="4"
      class="lang_selector"
      popoverClass="lang_selector__popover">
    <button class="lang_selector__button focus:outline-none">
      <template v-if="lang==='ru'">
        <img :src="flag_ru" alt="">
      </template>
      <template v-else>
        <img :src="flag_en" alt="">
      </template>
    </button>
    <template slot="popover">
      <div v-close-popover @click="changeLangBtn('ru')" class="lang_selector__item"><img :src="flag_ru" alt="">
      </div>
      <div v-close-popover @click="changeLangBtn('en')" class="lang_selector__item"><img :src="flag_en" alt="">
      </div>
    </template>
  </v-popover>
</template>

<script>
import {mapActions, mapState} from "vuex";
import flag_ru from '@/assets/icons/flags/ru.svg';
import flag_en from '@/assets/icons/flags/en.svg';

export default {
  name: "LangSelector",
  data() {
    return {
      flag_ru: flag_ru,
      flag_en: flag_en,
    }
  },
  computed: {
    ...mapState('i18n', [
      'lang',
    ]),
  },
  methods: {
    ...mapActions('i18n', ['changeLang',]),
    changeLangBtn(lang) {
      this.changeLang(lang);
    },
  },
}
</script>

<style lang="scss">
.lang_selector {
  @apply relative inline-block ml-6;

  &__button {
    @apply w-10 h-8 p-0 border border-gray-light rounded overflow-hidden cursor-pointer bg-transparent;
    img {
      width: 100%;
    }
  }

  &__popover {
    @apply outline-none;
    &.tooltip.popover .popover-arrow {
      @apply hidden;
    }

    &.tooltip.popover .popover-inner {
      @apply p-0 border rounded border-gray-light overflow-hidden bg-block;
    }
  }

  &__item {
    @apply w-14 py-2 px-2 bg-white transition duration-200 cursor-pointer;
    &:hover {
      @apply bg-primary-light;
    }
  }
}
</style>